var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home fit column items-center justify-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pageId),expression:"pageId"}],domProps:{"value":(_vm.pageId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pageId=$event.target.value}}}),_c('router-link',{attrs:{"to":{
      name: 'EditPage',
      params: {
        pageId: _vm.pageId || '123',
      },
    }}},[_c('q-btn',[_vm._v("edit")])],1),_c('div',[_vm._v(" "+_vm._s(_vm.pageId)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }